import styled from 'styled-components'

const colors = (color) => {
  const cls = {
    yellow: 'var(--warning)',
    red: 'var(--danger)',
    green: 'var(--success)'
  }

  return cls[color] || '***'
}

export const Container = styled.i`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  color: var(--theme-secondary);
  font-size: var(--font-size-sm);
  font-weight: bold;
  border-radius: 50%;
  font-style: normal;
  background: ${({ color }) => colors(color)};
`
